import { render } from "./Page1.vue?vue&type=template&id=dd9610d2&scoped=true"
import script from "./Page1.vue?vue&type=script&lang=js"
export * from "./Page1.vue?vue&type=script&lang=js"

import "./Page1.vue?vue&type=style&index=0&id=dd9610d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd9610d2"]])

export default __exports__